import { useAppSelector } from 'hooks';
import { getNavSectionList } from 'constants/navConstants';
import { TeamRole } from 'containers/app/app.model';
import {
  selectCurrentTeam,
  selectCurrentTeamAccountingPermissions,
  selectCurrentTeamReportsPermissions,
  selectIsOwner,
  selectMerchantCustomizations,
  selectPaymentSystemConfig,
  selectShowEstimatesSideNav
} from 'containers/app/appSlice';
import { selectCapitalFinancingEnabled } from 'containers/capital/capitalSlice';
import { PaymentSystem } from 'containers/payouts/constants';
import { PaymentSystemTransitionType } from 'containers/home/constants';

const GLOBAL_SEARCH_ROLES = [TeamRole.OWNER, TeamRole.ADMIN, TeamRole.DISPATCH_ADMIN, TeamRole.SUPER_ADMIN];

export const useGetSideNavList = () => {
  const { paymentSystem } = useAppSelector(selectPaymentSystemConfig) ?? {};
  const currentTeam = useAppSelector(selectCurrentTeam);
  const showEstimatesSideNav = useAppSelector(selectShowEstimatesSideNav);
  const { accessTeamAccounting } = useAppSelector(selectCurrentTeamAccountingPermissions) ?? {};
  const { accessReports } = useAppSelector(selectCurrentTeamReportsPermissions) ?? {};
  const isCapitalFinancingEnabled = useAppSelector(selectCapitalFinancingEnabled);
  const { teamFeatures } = useAppSelector(selectMerchantCustomizations) ?? {};
  const isOwner = useAppSelector(selectIsOwner);
  const isGlobalSearchRole = GLOBAL_SEARCH_ROLES.includes(currentTeam.role);

  const navSectionList = getNavSectionList({
    isLIP: paymentSystem === PaymentSystem.LIP,
    isTransitionTeam: currentTeam.paymentSystemTransitionType === PaymentSystemTransitionType.LIPConnectMigration,
    showIntegrations: currentTeam.integrationsEnabled,
    showBusinessLoans: false,
    showEstimateSettings: showEstimatesSideNav,
    showAccountingTab: accessTeamAccounting,
    showReports: accessReports,
    showCapital: isCapitalFinancingEnabled && teamFeatures?.financingEnabled && isOwner,
    showGlobalSearch: teamFeatures?.globalSearchEnabled && isGlobalSearchRole
  });

  return navSectionList;
};
